import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function ProofSection() {
  return <section className="bg-navy-900 py-20 md:py-28 relative text-cream-50" data-id="element-293">
      <div className="container mx-auto px-4" data-id="element-294">
        <div className="max-w-[800px] mx-auto text-center" data-id="element-295">
          <FadeIn data-id="element-296">
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-white mb-8" data-id="element-297">
              Lo que hace diferente a esta guía
            </h2>
          </FadeIn>

          <FadeIn delay={0.1} data-id="element-298">
            <div className="bg-navy-800 rounded-3xl p-8 md:p-12 border border-navy-700 shadow-2xl text-left" data-id="element-299">
              <p className="text-lg text-cream-100/90 leading-relaxed mb-6" data-id="element-300">
                A diferencia de los consejos genéricos que encuentras en
                internet ("bebe menos agua" o "evita el café"), este protocolo
                es{' '}
                <strong data-id="element-301">específico, directo y enfocado en la ejecución.</strong>
              </p>

              <p className="text-lg text-cream-100/90 leading-relaxed mb-6" data-id="element-302">
                No te pedimos que cambies toda tu vida. Nos enfocamos
                exclusivamente en tu <strong data-id="element-303">rutina nocturna</strong> y en las
                horas previas a dormir, porque ahí es donde se ganan o se
                pierden las noches.
              </p>

              <div className="bg-navy-900/50 p-6 rounded-2xl border-l-4 border-gold-500 mt-8" data-id="element-304">
                <p className="text-cream-100/80 italic" data-id="element-305">
                  "El objetivo no es darte teoría médica complicada, sino un
                  manual de instrucciones claro que puedas empezar a aplicar
                  esta misma noche."
                </p>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}